(function () {
  'use strict';

  function mountStoryCarousel(section) {
    if (!section || section.dataset.storyCarouselMounted === '1') return;

    const carousel = section.querySelector('[data-story-carousel]');
    const track = section.querySelector('[data-story-carousel-track]');
    const dots = Array.from(section.querySelectorAll('[data-story-carousel-dot]'));
    const slides = Array.from(track ? track.children : []);

    if (!carousel || !track || slides.length <= 1 || !dots.length) {
      section.dataset.storyCarouselMounted = '1';
      return;
    }

    const setActiveDot = index => {
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
    };

    const getNearestIndex = () => {
      const slideWidth = track.clientWidth || slides[0].clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / slideWidth)));
    };

    let scrollTimer = null;

    track.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          setActiveDot(getNearestIndex());
        }, 60);
      },
      { passive: true }
    );

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const index = Number(dot.getAttribute('data-story-carousel-index') || 0);
        const targetSlide = slides[index];
        if (!targetSlide) return;

        targetSlide.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        });

        setActiveDot(index);
      });
    });

    setActiveDot(0);
    section.dataset.storyCarouselMounted = '1';
  }

  function mountAllStoryCarousels(root) {
    (root || document).querySelectorAll('[data-story-carousel-section]').forEach(mountStoryCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      mountAllStoryCarousels(document);
    });
  } else {
    mountAllStoryCarousels(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    mountAllStoryCarousels(event.target);
  });
})();
